export const APP_REDUCER_NAME = 'appContainer';

export enum ACTIONS {
  SET_MENU_ACTIVE = 'SET_MENU_ACTIVE',
  SET_CITY_POPUP_ACTIVE = 'SET_CITY_POPUP_ACTIVE',
  SET_SELECT_CITY_DRAWER = 'SET_SELECT_CITY_DRAWER',
  SET_CITY = 'SET_CITY',
  SET_MENU_SEARCH_ACTIVE = 'SET_MENU_SEARCH_ACTIVE',
  SET_SEARCH_ACTIVE = 'SET_SEARCH_ACTIVE',
  SET_AUTH_DRAWER_ACTIVE = 'SET_AUTH_DRAWER_ACTIVE',
  SET_FAVOURITE_PRODUCTS = 'SET_FAVOURITE_PRODUCTS',
  SET_CART_DATA = 'SET_CART_DATA',
  SET_CART_DRAWER_ACTIVE = 'SET_CART_DRAWER_ACTIVE',
  SET_AVAILABLE_LOCATIONS = 'SET_AVAILABLE_LOCATIONS',
  SET_CATEGORY_TREE = 'SET_CATEGORY_TREE',
  SET_TEMP_CART_ITEMS = 'SET_TEMP_CART_ITEMS',
  SET_ORDER_USER_CORRECT = 'SET_ORDER_USER_CORRECT',
  SET_ORDER_DELIVERY_CORRECT = 'SET_ORDER_DELIVERY_CORRECT',
  SET_ORDER_COMPANY_INVOICE_CORRECT = 'SET_ORDER_COMPANY_INVOICE_CORRECT',
  SET_CATALOG_ACTIVE = 'SET_CATALOG_ACTIVE',
  SET_PARTNERS_DRAWER_ACTIVE = 'SET_PARTNERS_DRAWER_ACTIVE',
  SET_DELETED_CART_ITEMS = 'SET_DELETED_CART_ITEMS',
  ADD_DELETED_CART_ITEM = 'ADD_DELETED_CART_ITEM',
  REMOVE_DELETED_CART_ITEM = 'REMOVE_DELETED_CART_ITEM',
  SET_ALERT = 'SET_ALERT',
  SET_HEADER_BUTTON_COLOR = 'SET_HEADER_BUTTON_COLOR',
  SET_HELP_DRAWER_ACTIVE = 'SET_HELP_DRAWER_ACTIVE',
  SET_HELP_DRAWER_SCREEN = 'SET_HELP_DRAWER_SCREEN',
}
